import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from "@angular/router";

export const AuthGuard: CanActivateFn =
    async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
        const token: string = localStorage.getItem("token") ?? "";
        const grupo: string = localStorage.getItem("grupo") ?? "";
        const router = inject(Router);

        if (token != null && token && grupo != null && grupo) {
            if (state.url.startsWith("/login")) {
                return await router.navigate(["/"]);
            }

            return true;
        }

        if (!state.url.startsWith("/login")) {
            return await router.navigate(["/login"], { queryParams: { redirectTo: state.url } });
        }

        return true;
    }
